import axios from "axios";
import * as Preferences from "./Preferences";

export const GetCalendarItems = (offset, callback) => {
  console.log("IN GetCalendarItems REQUEST...");

  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.PREMATCH_INFO_HANDLER_GET_CALENDAR_ITEMS;

  //zovi axios
  axios
    .post(svcUrl, {
      offset: offset
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const GetTipNamesForMainBets = (jezikID, callback) => {
  console.log("IN GetTipNamesForMainBets REQUEST...");

  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.PREMATCH_INFO_HANDLER_GET_TIP_NAMES_FOR_MAIN_BETS;

  //zovi axios
  axios
    .post(svcUrl, {
      jezikID: jezikID
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const GetSportTournamentItems = (
  jezikID,
  datum,
  sportID,
  offset,
  lastMin,
  korisnikID,
  callback
) => {
  console.log("IN GetSportTournamentItems REQUEST...");

  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.PREMATCH_INFO_HANDLER_GET_SPORT_TOURNAMENT_ITEMS;

  //zovi axios
  axios
    .post(svcUrl, {
      jezikID: jezikID,
      datum: datum,
      sportID: sportID,
      offset: offset,
      lastMin: lastMin,
      korisnikID: korisnikID
    })
    .then(response => {
      console.log("Received response! ", response);

      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const GetActivePairItems = (
  jezikID,
  datum,
  sportID,
  offset,
  lastMin,
  korisnikID,
  callback
) => {
  console.log("IN GetActivePairItems REQUEST...");

  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.PREMATCH_INFO_HANDLER_GET_ACTIVE_PAIR_ITEMS;

  //zovi axios
  axios
    .post(svcUrl, {
      jezikID: jezikID,
      datum: datum,
      sportID: sportID,
      offset: offset,
      lastMin: lastMin,
      korisnikID: korisnikID
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const GetMostTippedPairs = (jezikID, sportID, resultCount, callback) => {
  console.log("IN GetMostTippedPairs REQUEST...");

  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.PREMATCH_INFO_HANDLER_GET_MOST_TIPPED_PAIRS;

  //zovi axios
  axios
    .post(svcUrl, {
      jezikID: jezikID,
      sportID: sportID,
      resultCount: resultCount
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const GetMostTippedSports = (jezikID, callback) => {
  console.log("IN GetMostTippedSports REQUEST...");

  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.PREMATCH_INFO_HANDLER_GET_MOST_TIPPED_SPORTS;

  //zovi axios
  axios
    .post(svcUrl, {
      jezikID: jezikID
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const GetMainBets = (jezikID, callback) => {
  console.log("IN GetMainBets REQUEST...");

  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.PREMATCH_INFO_HANDLER_GET_MAIN_BETS;

  //zovi axios
  axios
    .post(svcUrl, {
      jezikID: jezikID
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const GetPairDetails = (jezikID, matchID, callback) => {
  console.log("IN GetPairDetails REQUEST...");

  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.PREMATCH_INFO_HANDLER_GET_PAIR_DETAILS;

  //zovi axios
  axios
    .post(svcUrl, {
      jezikID: jezikID,
      matchID: matchID
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const GetPairDetailsForTicket = (jezikID, coefID, callback) => {
  console.log("IN GetPairDetailsForTicket REQUEST...");

  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.PREMATCH_INFO_HANDLER_GET_PAIR_DETAILS_FOR_TICKET;

  //zovi axios
  axios
    .post(svcUrl, {
      jezikID: jezikID,
      coefID: coefID
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const GetTicketPairs = (
  jezikID,
  coefIDs,
  callback,
  match,
  bet,
  sport
) => {
  console.log("IN GetTicketPairs REQUEST...");

  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.PREMATCH_INFO_HANDLER_GET_TICKET_PAIRS;

  //zovi axios
  axios
    .post(svcUrl, {
      jezikID: jezikID,
      coefIDs: coefIDs
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data, match, bet, sport);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null, match, bet, sport);
      }
    });
};

export const GetAdditionalBetNamesForPair = (jezikID, matchID, callback) => {
  console.log("IN GetAdditionalBetNamesForPair REQUEST...");

  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.PREMATCH_INFO_HANDLER_GET_ADDITIONAL_BET_NAMES_FOR_PAIR;

  //zovi axios
  axios
    .post(svcUrl, {
      jezikID: jezikID,
      matchID: matchID
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const GetAdditionalBetOddsForPair = (jezikID, matchID, callback) => {
  console.log("IN GetAdditionalBetOddsForPair REQUEST...");

  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.PREMATCH_INFO_HANDLER_GET_ADDITIONAL_BET_ODDS_FOR_PAIR;

  //zovi axios
  axios
    .post(svcUrl, {
      jezikID: jezikID,
      matchID: matchID
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const GetBetDetails = (jezikID, betID, callback) => {
  console.log("IN GetBetDetails REQUEST...");

  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.PREMATCH_INFO_HANDLER_GET_BET_DETAILS;

  //zovi axios
  axios
    .post(svcUrl, {
      jezikID: jezikID,
      betID: betID
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data, betID);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const GetPairsForBetType = (
  date,
  jezikID,
  vrstaOkladeID,
  offset,
  lastmin,
  callback
) => {
  console.log("IN GetPairsForBetType REQUEST...");

  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.PREMATCH_INFO_HANDLER_GET_PAIRS_FOR_BET_TYPE;

  //zovi axios
  axios
    .post(svcUrl, {
      date: date,
      betTypeID: vrstaOkladeID,
      jezikID: jezikID,
      offset: offset,
      lastMin: lastmin
    })
    .then(response => {
      console.log("Received response! ", response);

      if (callback) {
        callback(response.data, vrstaOkladeID);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const GetSuperTipPairs = (jezikID, callback) => {
  console.log("IN GetSuperTipPairs REQUEST...");

  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.PREMATCH_INFO_HANDLER_GET_SUPER_TIP_PAIRS;

  //zovi axios
  axios
    .post(svcUrl, {
      jezikID: jezikID
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const GetFavoritPlusPairs = (jezikID, callback) => {
  console.log("IN GetFavoritPlusPairs REQUEST...");

  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.PREMATCH_INFO_HANDLER_GET_FAVORIT_PLUS_PAIRS;

  //zovi axios
  axios
    .post(svcUrl, {
      jezikID: jezikID
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const GetTopLeagues = (jezikID, offset, callback) => {
  console.log("IN GetTopLeagues REQUEST...");

  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.PREMATCH_INFO_HANDLER_GET_TOP_LEAGUES;

  //zovi axios
  axios
    .post(svcUrl, {
      jezikID: jezikID,
      offset: offset
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};



// WEBPACK FOOTER //
// ./src/Communication/PrematchInfoServicesHandler.js